export const DATA_FRESHNESS_BUTTON_ID = 'data-freshness-button';
